(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-banner-switch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jg-banner-switch')) {
    customElements.define(
      'jg-banner-switch',
      class JgBannerSwitch extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('.jg-banner__tab')];
          this.panels = [...this.querySelectorAll('.jg-banner__panel')];
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
              event.preventDefault();
              const step = event.key === 'ArrowRight' ? 1 : -1;
              const next = (index + step + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
          this.panels.forEach((panel, index) => {
            panel.addEventListener('shopify:block:select', () => this.select(index));
          });
          this.switchEl = this.querySelector('.jg-banner__switch');
          this.current = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
          if (this.switchEl) {
            this.moveIndicator(this.current, false);
            this.switchEl.classList.add('is-ready');
            this.onResize = () => this.moveIndicator(this.current, false);
            window.addEventListener('resize', this.onResize);
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResize);
          }
        }

        disconnectedCallback() {
          if (this.onResize) window.removeEventListener('resize', this.onResize);
        }

        moveIndicator(index, animate) {
          const tab = this.tabs[index];
          if (!tab || !this.switchEl) return;
          const box = this.switchEl.getBoundingClientRect();
          const rect = tab.getBoundingClientRect();
          const border = this.switchEl.clientLeft;
          const left = rect.left - box.left - border;
          const right = box.right - rect.right - border;
          const forward = index > this.current;
          const style = this.switchEl.style;
          style.setProperty('--jg-ind-left-delay', animate && forward ? '0.07s' : '0s');
          style.setProperty('--jg-ind-right-delay', animate && !forward ? '0.07s' : '0s');
          if (!animate) {
            const indicator = this.switchEl.querySelector('.jg-banner__indicator');
            indicator.style.transition = 'none';
            style.setProperty('--jg-ind-left', `${left}px`);
            style.setProperty('--jg-ind-right', `${right}px`);
            indicator.getBoundingClientRect();
            indicator.style.transition = '';
            return;
          }
          style.setProperty('--jg-ind-left', `${left}px`);
          style.setProperty('--jg-ind-right', `${right}px`);
        }

        select(index) {
          if (this.switchEl) this.moveIndicator(index, true);
          this.current = index;
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel, i) => {
            const active = i === index;
            if (active) {
              panel.hidden = false;
              panel.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
            }
            panel.classList.toggle('is-active', active);
            if (!active) panel.hidden = true;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-color-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jg-color-carousel')) {
    customElements.define(
      'jg-color-carousel',
      class JgColorCarousel extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.jg-colors__list');
          this.buttons = this.querySelectorAll('.jg-colors__button');
          if (!this.list || this.buttons.length === 0) return;

          this.update = this.update.bind(this);
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.scrollByPage(Number(button.dataset.direction)));
          });
          this.list.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.list);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        scrollByPage(direction) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollBy({ left: direction * this.list.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        update() {
          const maxScroll = this.list.scrollWidth - this.list.clientWidth;
          this.toggleAttribute('data-scrollable', maxScroll > 2);
          this.buttons[0].disabled = this.list.scrollLeft <= 2;
          this.buttons[1].disabled = this.list.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-review-photos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    const init = () => {
      if (calm.matches || !('IntersectionObserver' in window)) return;
      document.querySelectorAll('.jg-reviews:not([data-jg-stars])').forEach((section) => {
        section.dataset.jgStars = 'true';
        section.classList.add('jg-stars-ready');
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            section.classList.add('jg-stars-in');
            observer.disconnect();
          },
          { threshold: 0.3 }
        );
        observer.observe(section);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-tiktok"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jg-video-row')) {
    customElements.define(
      'jg-video-row',
      class JgVideoRow extends HTMLElement {
        connectedCallback() {
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.loadPosters();
          this.querySelectorAll('.jg-social__video-frame').forEach((frame) => {
            const video = frame.querySelector('video');
            const button = frame.querySelector('.jg-social__video-toggle');
            if (!video || !button) return;
            video.muted = true;
            video.playsInline = true;
            video.addEventListener('play', () => {
              button.classList.add('is-playing');
              button.setAttribute('aria-label', button.dataset.labelPause);
            });
            video.addEventListener('pause', () => {
              button.classList.remove('is-playing');
              button.setAttribute('aria-label', button.dataset.labelPlay);
            });
            button.addEventListener('click', () => {
              if (video.paused) {
                video.dataset.userPaused = 'false';
                this.play(video);
              } else {
                video.dataset.userPaused = 'true';
                video.pause();
              }
            });
          });
          if (this.dataset.autoplay !== 'true' || this.reduceMotion || !('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                  if (video.dataset.userPaused !== 'true') this.play(video);
                } else {
                  video.pause();
                }
              });
            },
            { threshold: 0.6 }
          );
          this.querySelectorAll('video').forEach((video) => this.observer.observe(video));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.posterObserver) this.posterObserver.disconnect();
        }

        loadPosters() {
          const videos = [...this.querySelectorAll('video[data-poster]')];
          const show = (video) => {
            if (!video.dataset.poster) return;
            video.poster = video.dataset.poster;
            video.removeAttribute('data-poster');
          };
          if (!('IntersectionObserver' in window)) {
            videos.forEach(show);
            return;
          }
          this.posterObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                show(entry.target);
                this.posterObserver.unobserve(entry.target);
              });
            },
            { rootMargin: '400px 400px' }
          );
          videos.forEach((video) => this.posterObserver.observe(video));
        }

        play(video) {
          this.querySelectorAll('video').forEach((other) => {
            if (other !== video && !other.paused) other.pause();
          });
          video.muted = true;
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
